import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function CoffeeTeaPage() {

    const heroData = [
        {
          title: "Coffee & Tea",
          content: "Discover the perfect harmony of flavors in our coffee and tea selection. From rich, aromatic brews to soothing herbal blends, we offer something for every palate. Whether you need a bold espresso to energize your day or a calming cup of tea to unwind, our carefully curated beverages promise quality, freshness, and a moment of pure enjoyment.",
          image: images.CoffeeHeroImage, 
        },
      ];

    const HotCoffeeData = [
      {
        name: "Espresso",
        price: 0,
        image: [
          images.HotCoffee1,
        ]
      },
      {
        name: "Americano",
        price: 0,
        image: [
          images.HotCoffee2,
        ]
      },
      {
        name: "Cappuccino",
        price: 0,
        image: [
          images.HotCoffee3,
        ]
      },
      {
        name: "Flat White",
        price: 0,
        image: [
          images.HotCoffee4,
        ]
      },
      {
        name: "Macchiato",
        price: 0,
        image: [
          images.HotCoffee5,
        ]
      },
      {
        name: "Affogato",
        price: 0,
        image: [
          images.HotCoffee6,
        ]
      },
      {
        name: "Turkish Coffee",
        price: 0,
        image: [
          images.HotCoffee7,
        ]
      },
      {
        name: "Latte",
        price: 0,
        image: [
          images.HotCoffee8,
        ]
      },
      {
        name: "Spanish Latte",
        price: 0,
        image: [
          images.HotCoffee9,
        ]
      },
      {
        name: "Pistachio Latte",
        price: 0,
        image: [
          images.HotCoffee10,
        ]
      },
      {
        name: "Honey Cardamom Latte",
        price: 0,
        image: [
          images.HotCoffee11,
        ]
      },
      {
        name: "Mocha",
        price: 0,
        image: [
          images.HotCoffee12,
        ]
      },
    ]

    const ColdBrewsData = [
      {
        name: "Cold Brew",
        price: 0,
        image: [
          images.ColdBrew1,
        ]
      },
      {
        name: "Vanilla Sweet Cream Cold Brew",
        price: 0,
        image: [
          images.ColdBrew2,
        ]
      },
    ]

    const HotTeaData = [
      {
        name: "English Breakfast",
        price: 0,
        image: [
          images.HotTea1,
        ]
      },
      {
        name: "Earl Grey",
        price: 0,
        image: [
          images.HotTea2,
        ]
      },
      {
        name: "Chamomile",
        price: 0,
        image: [
          images.HotTea3,
        ]
      },
      {
        name: "Jasmine Green Tea",
        price: 0,
        image: [
          images.HotTea4,
        ]
      },
      {
        name: "Peppermint Tea",
        price: 0,
        image: [
          images.HotTea5,
        ]
      },
      {
        name: "Chai Latte",
        price: 0,
        image: [
          images.HotTea6,
        ]
      },
      {
        name: "Matcha Latte",
        price: 0,
        image: [
          images.HotTea7,
        ]
      },
    ]

    const IcedTeaData = [
      {
        name: "Classic Iced Black Tea",
        price: 0,
        image: [
          images.IcedTea1,
        ]
      },
      {
        name: "Peach Iced Tea",
        price: 0,
        image: [
          images.IcedTea2,
        ]
      },
      {
        name: "Hibiscus Iced Tea",
        price: 0,
        image: [
          images.IcedTea3,
        ]
      },
      {
        name: "Lemon Green Iced Tea",
        price: 0,
        image: [
          images.IcedTea4,
        ]
      },
      {
        name: "Raspberry Mint Iced Tea",
        price: 0,
        image: [
          images.IcedTea5,
        ]
      },
    ]

    const MatchaTeaData = [
      {
        name: "Matcha Latte",
        price: 0,
        image: [
          images.MatchaTea1,
        ]
      },
      {
        name: "Matcha Coconut Latte",
        price: 0,
        image: [
          images.MatchaTea2,
        ]
      },
      {
        name: "Vanilla Almond Matcha Latte",
        price: 0,
        image: [
          images.MatchaTea3,
        ]
      },
      {
        name: "Rose Matcha Latte",
        price: 0,
        image: [
          images.MatchaTea4,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Cappuccino",
        image1: [
          images.HotCoffee3,
        ],
        content1: "",
        name2: "Honey Cardamom Latte",
        image2: [
          images.HotCoffee11,
        ],
        content2: ""
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={HotCoffeeData} title="Hot Coffee" />
            <ProductsSection productData={ColdBrewsData} title="Specialty Cold Brews" />
            <ProductsSection productData={HotTeaData} title="Classic Hot Teas" />
            <ProductsSection productData={IcedTeaData} title="Iced Teas" />
            <ProductsSection productData={MatchaTeaData} title="Matcha Tea Drinks" />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
